import ConnectionIcon from './component'

export default ConnectionIcon
